__webpack_require__.p = "https://assets-01.periodica.press/7368313-24501752154/";